/* eslint-disable no-unused-vars */
export enum ButtonIconComponentVariant {
  white = 'white',
  green = 'green',
  blank = 'blank'
};
